import api from "../api/axiosConfig";


const authService = {
  login: (data) => api.post("/login", data),
  logout: () => api.post("/logout"),
  getMe: () => api.get("/me"),
};

export default authService;
